// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper_38TAU","ant-modal-content":"index_ant-modal-content_3rfyW","button":"index_button_1Nz0Y"};